import { atom } from "jotai";
import { Fund } from "../types/Fund";

/**
 * Jotai atom for storing the list of all funds.
 * Manages the collection of Fund objects available in the application.
 * Initial state is an empty array.
 */
export const FundAtom = atom<Fund[]>([]);

/**
 * Jotai atom for storing the currently selected fund.
 * Used to track which fund is currently being viewed or edited.
 * Initial state is undefined (no fund selected).
 */
export const SelectedFundAtom = atom<Fund | undefined>(undefined);
